import { OverallAnalyticsDto, WinLossAnalyticsDto } from '@/infrastructure/network/dto/PlayerStatsDto';

interface PlayerScoreStatusProps {
	overallAnalytics?: OverallAnalyticsDto;
	winLossAnalytics?: WinLossAnalyticsDto;
	statusType?: 'overallAnalytics' | 'winLossAnalytics';
}
export const PlayerScoreStatus = ({ overallAnalytics, winLossAnalytics, statusType }: PlayerScoreStatusProps) => (
	<div className="p-5 text-xl font-medium text-gray-900">
		{statusType == 'overallAnalytics' ? <ScoreStatusOverall stats={overallAnalytics!} /> : <ScoreStatusWinLoss stats={winLossAnalytics!} />}
	</div>
);

const ScoreStatusOverall = ({ stats }: { stats: OverallAnalyticsDto }) => {
	return (
		<div className="flex flex-col gap-5">
			<div className="flex justify-between gap-2">
				<p className="font-medium text-base text-gray-600">Total points won</p>
				<p className="font-semibold text-lg">{stats?.totalPointsWon || stats?.totalPointsWon === 0 ? stats.totalPointsWon : '-'}</p>
			</div>

			<div className="flex justify-between gap-2">
				<p className="font-medium text-base text-gray-600">Total points lost</p>
				<p className="font-semibold text-lg">{stats?.totalPointsLost || stats?.totalPointsLost === 0 ? stats.totalPointsLost : '-'}</p>
			</div>

			<div className="flex justify-between gap-2">
				<p className="font-medium text-base text-gray-600">Total games won</p>
				<p className="font-semibold text-lg">{stats?.totalGamesWon || stats?.totalGamesWon === 0 ? stats.totalGamesWon : '-'}</p>
			</div>

			<div className="flex justify-between gap-2">
				<p className="font-medium text-base text-gray-600">Total games lost</p>
				<p className="font-semibold text-lg">{stats?.totalGamesLost || stats?.totalGamesLost === 0 ? stats.totalGamesLost : '-'}</p>
			</div>

			<div className="flex justify-between gap-2">
				<p className="font-medium text-base text-gray-600">Longest Winning Match Streak</p>
				<p className="font-semibold text-lg">{stats?.matchStreak || stats?.matchStreak === 0 ? stats.matchStreak : '-'}</p>
			</div>
		</div>
	);
};

const ScoreStatusWinLoss = ({ stats }: { stats: WinLossAnalyticsDto }) => {
	return (
		<div className="flex flex-col gap-5">
			<div className="flex justify-between gap-2">
				<div className="w-3/4">
					<p className="font-medium text-base text-gray-600">Versus higher team</p>
					<p className="text-xs text-gray-400">How many matches were won/lost against teams that are higher rated</p>
				</div>
				<p className="font-semibold text-lg">
					{stats?.totalMatchesWonVsHigherRatedTeam != null && stats?.totalMatchesLostVsHigherRatedTeam != null
						? `${stats.totalMatchesWonVsHigherRatedTeam}-${stats.totalMatchesLostVsHigherRatedTeam}`
						: '-'}
				</p>
			</div>

			<div className="flex justify-between gap-2">
				<div className="w-3/4">
					<p className="font-medium text-base text-gray-600">Deciding games (3rd/5th)</p>
					<p className="text-xs text-gray-400">How many win/loss of games when playing the 3rd or 5th game in the match</p>
				</div>
				<p className="font-semibold text-lg">
					{stats?.totalMatchesWonInDecidingGames != null && stats?.totalMatchesLostInDecidingGames != null
						? `${stats.totalMatchesWonInDecidingGames}-${stats.totalMatchesLostInDecidingGames}`
						: '-'}
				</p>
			</div>

			{/* <div className="flex justify-between gap-2">
				<p className="font-medium">Indoor</p>
				<p className="text-indigo-900 font-semibold">
					{stats.}-{stats.indoor.loss}
				</p>
			</div>

			<div className="flex justify-between gap-2">
				<p className="font-medium">Outdoor</p>
				<p className="text-indigo-900 font-semibold">
					{stats.outdoor.win}-{stats.outdoor.loss}
				</p>
			</div> */}

			<div className="flex justify-between gap-2">
				<div className="w-3/4">
					<p className="font-medium text-base text-gray-600">After winning game</p>
					<p className="text-xs text-gray-400">How many matches were won/lost after winning first game</p>
				</div>
				<p className="font-semibold text-lg">
					{stats?.totalMatchesWonAfterWinningFirstGame}-{stats?.totalMatchesLostAfterWinningFirstGame}
				</p>
			</div>
		</div>
	);
};
